import { useEffect, useState } from "react";
import api from "../lib/api";
import { Star, ArrowUpRight } from "lucide-react";

export default function StateSponsorBanner({ state }) {
  const [sponsors, setSponsors] = useState([]);

  useEffect(() => {
    if (!state) { setSponsors([]); return; }
    api.get(`/state-sponsors?state=${state}`).then((r) => setSponsors(r.data)).catch(() => setSponsors([]));
  }, [state]);

  if (!sponsors.length) return null;
  const s = sponsors[0];
  return (
    <a
      href={s.apply_url}
      target="_blank"
      rel="noreferrer"
      data-testid={`state-sponsor-${state}`}
      className="block border border-yellow-500 bg-yellow-500/10 hover:bg-yellow-500/20 p-5 mb-6 transition-colors relative"
    >
      <div className="flex items-start justify-between gap-4">
        <div>
          <div className="flex items-center gap-2 text-xs font-mono-alt uppercase text-yellow-500 tracking-widest mb-1">
            <Star size={12} /> Sponsored &middot; {state}
          </div>
          <div className="font-display text-2xl md:text-3xl uppercase leading-none text-white">{s.headline}</div>
          <div className="text-sm text-zinc-300 mt-2 max-w-3xl">{s.message}</div>
          <div className="text-xs text-zinc-500 mt-2 font-mono-alt">By {s.employer}</div>
        </div>
        <ArrowUpRight className="text-yellow-500 shrink-0" size={20} />
      </div>
    </a>
  );
}
